import React from 'react';
import { Code } from './code';
import lightTheme from 'prism-react-renderer/themes/github';

export function CodeSnippet({ body, theme, withCopy, withLineNumbers }: any) {
  return (
    <div className="relative my-4 not-prose">
      <Code
        filename={body.filename}
        theme={theme === 'light' ? lightTheme : theme}
        language={body.language}
        highlightedLines={body.highlightedLines}
        withLineNumbers={withLineNumbers}
        withCopy={withCopy}
      >
        {body.code}
      </Code>
    </div>
  );
}
